import { render, staticRenderFns } from "./full-wiki-list.vue?vue&type=template&id=cdd77700&"
import script from "./full-wiki-list.vue?vue&type=script&lang=ts&"
export * from "./full-wiki-list.vue?vue&type=script&lang=ts&"
import style0 from "./full-wiki-list.vue?vue&type=style&index=0&id=cdd77700&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports